import React, { useState } from "react";
import axios from "axios";
import { useDispatch } from 'react-redux';
import {  
    fetchWspolnotaWazneNumery
  } from '../../Redux/Actions.js'; 

const WspolnotyWazneNumeryDodaj = props =>{

    const { setActiveWindow, idw } = props;

    const dispatch = useDispatch();

    const [numer, setNumer] = useState("");
    const [opis, setOpis] = useState("");
    
    const handleNumer = e => setNumer(e.target.value);
    const handleOpis = e => setOpis(e.target.value);
    
    const handleAnuluj = () => setActiveWindow("lista");

    const handleZapisz = async () => {
        try {   
            // Wysyłamy dane na serwer
            await axios.post('/api/wspolnota/wazne-numery/dodaj', {
              idw: idw,
              numer: numer,
              opis: opis
            }).then(response => {
                if (response.status === 200) {
                    dispatch(fetchWspolnotaWazneNumery(idw)); 
                    setNumer("");
                    setOpis("");
                    setActiveWindow("lista");
                }
            });
        } catch (error) {
            console.error('Błąd podczas dodawania danych:', error);
        }
    }

    return (
        <div className="wspolnotyUliceDodaj">
            <div className="naglowek">
                <h3>
                    Dodawanie Numeru
                </h3>
            </div>
            <div>
                <p>Numer:</p>
                <input 
                    type="text" 
                    onChange={handleNumer} 
                    value={numer}
                />
            </div>
            <div>
                <p>Opis:</p>
                <input 
                    type="text" 
                    onChange={handleOpis} 
                    value={opis}
                />
            </div>
            <button 
                onClick={handleZapisz}
            >
                Dodaj
            </button>
            <button
                onClick={handleAnuluj}
            >  
                Anuluj
            </button>
        </div>
    )
}

export default WspolnotyWazneNumeryDodaj;